<template lang="pug">
study-result-last-minute-check-list.study-result-last-minute-check(
  :moveReturnEvent='moveReturnEvent',
  :resultDetailTitle='resultDetailTitle',
  :images='images',
  :studyResultLastMinuteChecks='studyResultLastMinuteChecks',
  :showRetryButton='showRetryButton',
  :retryButtonEvent='retryButtonEvent'
)
  template(#returnButtonText) 戻る
  template(#titleLabel) の結果
  template(#problemNumberHeader) 大問番号
  template(#questionNumberHeader) 小問番号
  template(#correctAnswerHeader) 正解情報
  template(#correctSymbolHeader) 今回の結果
  template(#previousCorrectSymbolHeader) 前回の結果
  template(#previousTwoCorrectSymbolHeader) 前々回の結果
  template(#AnnotationText) …テスト前にもう一度確認しましょう
  template(#retryButtonText) もう一度挑戦
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import StudyResultLastMinuteCheckList from '@/components/templates/student/StudyResultLastMinuteCheckList.vue'
import { StudyResultDetailImage, StudyResultLastMinuteCheckType } from '@/models/studyResultDetailModel'
import { StudyResultUtils } from '@/utils/StudyResultUtils'
import StudentStudyResultDetailApi from '@/mixins/api/student/StudentStudyResultDetailApi'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * テスト結果直前チェック画面
 */
@Component({
  components: {
    StudyResultLastMinuteCheckList,
  },
})
export default class StudyResultLastMinuteCheck extends Mixins(StudentStudyResultDetailApi) {
  // 小項目ID
  private get sUnitId(): number {
    return Number(this.$route.params.sUnitId)
  }

  // 結果詳細タイトル
  private resultDetailTitle = ''

  // 画像情報
  private images: StudyResultDetailImage[] = []

  // テスト結果直前チェック詳細表示情報
  private studyResultLastMinuteChecks: StudyResultLastMinuteCheckType[] = []

  // 再挑戦ボタン表示フラグ
  private showRetryButton = false

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    // 結果詳細情報を取得
    this.$loading.start()

    this.images = await this.getStudentStudyResultImageUrl(this.sUnitId, SUnitCategorySetting.LAST_MINUTE_CHECK)
    const apiResponse = await this.getStudentStudyResultLastMinuteCheck(this.sUnitId)
    this.resultDetailTitle = StudyResultUtils.getStudyResultLastMinuteCheckTitle(apiResponse)
    this.studyResultLastMinuteChecks = StudyResultUtils.buildStudyResultLastMinuteChecks(apiResponse)
    // APIレスポンスが取得できなければ再挑戦ボタンは非表示
    this.showRetryButton = !!apiResponse
    this.$loading.complete()
  }

  // 戻るボタン押下時イベント
  private moveReturnEvent() {
    this.$router.push({ name: 'StudentStudyResult' })
  }

  // 再挑戦ボタン押下時イベント
  private retryButtonEvent() {
    // 学習済みフラグを持ってこの小項目の扉画面へ遷移
    this.$router.push({
      name: 'StudentStudyTop',
      query: {
        sUnitId: String(this.sUnitId),
        isLearned: 'true',
      },
    })
  }
}
</script>
